import React from "react";

const ConnectionMethodCard = ({
    icon: Icon,
    title,
    description,
    note,
    buttonLabel,
    disabled = false,
    disabledReason,
    onButtonClick,
    variant = "default",
    children,
}) => {
    const isGoogleVariant = variant === "google";
    const buttonClassName = isGoogleVariant
        ? "inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-indigo-500 to-blue-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:from-indigo-600 hover:to-blue-600 disabled:cursor-not-allowed disabled:from-indigo-200 disabled:to-blue-200 disabled:text-indigo-500 disabled:shadow-none sm:w-auto sm:min-w-[190px]"
        : "inline-flex w-fit shrink-0 items-center justify-center rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 disabled:cursor-not-allowed disabled:bg-indigo-200 disabled:text-indigo-500 disabled:shadow-none";
    const hasFooterText = note || disabledReason;

    return (
        <article className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm transition sm:p-5">
            <div className="flex items-start gap-3">
                {Icon &&
                    (isGoogleVariant ? (
                        <div className="relative flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-50 via-violet-50 to-white text-indigo-600 ring-1 ring-indigo-100 sm:h-20 sm:w-20">
                            <div className="absolute left-3 top-3 h-8 w-8 rounded-xl bg-indigo-100/80 sm:h-10 sm:w-10" />
                            <div className="absolute bottom-3 left-4 h-6 w-9 rounded-lg bg-indigo-200/60 sm:h-7 sm:w-11" />
                            <div className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-white text-indigo-600 shadow-sm ring-1 ring-indigo-100 sm:h-12 sm:w-12 sm:rounded-2xl">
                                <Icon
                                    size={22}
                                    className="sm:h-6 sm:w-6"
                                    aria-hidden="true"
                                />
                            </div>
                            <div className="absolute bottom-2 right-2 flex h-7 w-7 items-center justify-center rounded-full bg-white text-xs font-bold text-blue-600 shadow-sm ring-1 ring-slate-100 sm:h-8 sm:w-8">
                                G
                            </div>
                        </div>
                    ) : (
                        <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 ring-1 ring-indigo-100">
                            <Icon size={24} aria-hidden="true" />
                        </div>
                    ))}

                <div className="min-w-0 flex-1">
                    <h3 className="text-base font-semibold text-slate-900">
                        {title}
                    </h3>
                    <p className="mt-1 text-sm leading-6 text-slate-600">
                        {description}
                    </p>
                </div>
            </div>

            {buttonLabel && (
                <button
                    type="button"
                    onClick={onButtonClick}
                    disabled={disabled}
                    className={`mt-4 ${buttonClassName}`}
                >
                    {isGoogleVariant && (
                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white text-xs font-bold text-blue-600">
                            G
                        </span>
                    )}
                    {buttonLabel}
                </button>
            )}

            {children && <div className="mt-4">{children}</div>}

            {hasFooterText && (
                <div className="mt-3 space-y-1 text-xs font-medium text-slate-500">
                    {note && <p className="whitespace-normal">{note}</p>}
                    {disabledReason && <p>{disabledReason}</p>}
                </div>
            )}
        </article>
    );
};

export default ConnectionMethodCard;
